import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import { validateOrderlessCondition } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type OrderlessState = void;

export const ORDERLESS = (
  Details: React.ComponentType<ConditionTypeDetailsProps<OrderlessState>>,
): ConditionType<OrderlessState, Condition.Orderless> => ({
  name: CONDITION_NAMES[Condition.ORDERLESS],
  description() {
    return t(
      "No order associated with the request. Usually orders created from product registrations",
    );
  },
  Details(props: ConditionTypeDetailsProps<OrderlessState>) {
    return React.createElement(Details, props);
  },
  empty: undefined,
  fromModel() {},
  toModel() {
    return { type: Condition.ORDERLESS };
  },
  valid() {
    return validateOrderlessCondition({}).valid;
  },
});
